import { createSlice } from '@reduxjs/toolkit';
import {
  acceptClientAppointmentBuilder,
  createAppointmentForClientBuilder,
  createAppointmentForLeadClientBuilder,
  createUnavailableAppointmentBuilder,
  deleteAppointmentBuilder,
  editAppointmentBuilder,
  getClientAppointmentsBuilder,
  getVendorAppointmentsBuilder,
  getVendorOccupiedPeriodBuilder,
  rejectClientAppointmentBuilder,
} from './builder';

const initialState = {
  getClientAppointmentsPending: false,
  createAppointmentForClientPending: false,
  getVendorOccupiedPeriodPending: false,
  getVendorAppointmentsPending: false,
  editAppointmentPending: false,
  createUnavailableAppointmentPending: false,
  acceptClientAppointmentPending: false,
  rejectClientAppointmentPending: false,
  deleteAppointmentPending: false,
  createAppointmentForLeadClientPending: false,

  clientAppointments: {
    data: [],
  },

  vendorAppointments: {
    data: [],
  },
};
export const appointmentSlice = createSlice({
  name: 'appointmentInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getClientAppointmentsBuilder(builder);
    createAppointmentForClientBuilder(builder);
    getVendorOccupiedPeriodBuilder(builder);
    getVendorAppointmentsBuilder(builder);
    editAppointmentBuilder(builder);
    createUnavailableAppointmentBuilder(builder);
    acceptClientAppointmentBuilder(builder);
    rejectClientAppointmentBuilder(builder);
    deleteAppointmentBuilder(builder);
    createAppointmentForLeadClientBuilder(builder);
    builder.addCase('logout', () => initialState);
  },
});

export const selectClientAppointments = state => state.appointmentInfo.clientAppointments;
export const selectGetClientAppointmentsPending = state => state.appointmentInfo.getClientAppointmentsPending;
export const selectCreateAppointmentForClientPending = state => state.appointmentInfo.createAppointmentForClientPending;
export const selectGetVendorOccupiedPeriodPending = state => state.appointmentInfo.getVendorOccupiedPeriodPending;
export const selectVendorAppointments = state => state.appointmentInfo.vendorAppointments;
export const selectGetVendorAppointmentsPending = state => state.appointmentInfo.getVendorAppointmentsPending;
export const selectEditAppointmentPending = state => state.appointmentInfo.editAppointmentPending;
export const selectCreateUnavailableAppointmentPending = state =>
  state.appointmentInfo.createUnavailableAppointmentPending;
export const selectAcceptClientAppointmentPending = state => state.appointmentInfo.acceptClientAppointmentPending;
export const selectRejectClientAppointmentPending = state => state.appointmentInfo.rejectClientAppointmentPending;
export const selectDeleteAppointmentPending = state => state.appointmentInfo.deleteAppointmentPending;
export const selectCreateAppointmentForLeadClientPending = state =>
  state.appointmentInfo.createAppointmentForLeadClientPending;

// export const {} = appointmentSlice.actions;

export default appointmentSlice.reducer;
